<template>
  <vip-sonko-layout>
    <v-layout wrap>
        <v-flex xs12 class="px-3">
            <v-toolbar flat dense color="toolbarColor">
        <v-toolbar-title class="title">Assigned Expert</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn flat class="right" color="primary" to="/vip_sonko/jobs/assigned">Back</v-btn>
      </v-toolbar>
        </v-flex>
      <!-- job details -->
      <engagements :engagements="engagements"></engagements>
      <!-- end -->
    </v-layout>
  </vip-sonko-layout>
</template>

<script>
import Engagements from '../_components/bidder';

export default {
    name: 'JobEngagements',
    components: {
      Engagements
    },
    data() {
      return {
       engagements: []
      }
    },
    methods: {

    },
    created() {
      const id = this.$route.params.id;
      const self = this;
      this.$store.dispatch("get", '/engagement/'+ id).then(res => {
          if(res.engagements.length>0){
              self.engagements = res.engagements;
          }
      });
    }
}
</script>
